import { GLOBALS } from '../globals'
import { createButtonComponents } from '../setup-factories'

export const { Button, ButtonSmall } = createButtonComponents(
  {
    background: { color: GLOBALS.color.turquoise[500] },
    padding: { top: '13px', right: '12px', bottom: '11px', left: '12px' },
    border: { radius: '6px' },
    font: { family: GLOBALS.font.title.family, color: 'white', size: '16px', lineHeight: '24px', whiteSpace: 'nowrap' },
    transition: { backgroundColor: GLOBALS.transition.default },
    $when: {
      active: {},
      disabled: {},
      focus: { background: { color: GLOBALS.color.turquoise[400] } },
      hover: { background: { color: GLOBALS.color.turquoise[400] } }
    }
  },
  {
    Button: {},
    Small: { padding: { top: '9px', right: '12px', bottom: '8px', left: '12px' } }
  }
)
